'use client';
// Le lien du site : un `next/link` qui garde la langue de la page. À employer à la place de
// `next/link` pour toute adresse INTERNE ; les adresses externes passent telles quelles.
// Tant que le routage par langue est éteint, il ne change aucune adresse.

import NextLink from 'next/link';
import { forwardRef, type ComponentProps } from 'react';
import { localiser } from '@/lib/i18n/config';
import { useLang } from './LangProvider';

type Props = ComponentProps<typeof NextLink>;

const Link = forwardRef<HTMLAnchorElement, Props>(function Link({ href, ...reste }, ref) {
  const lang = useLang();
  const cible =
    typeof href === 'string'
      ? localiser(href, lang)
      : href.pathname
        ? { ...href, pathname: localiser(href.pathname, lang) }
        : href;
  return <NextLink ref={ref} href={cible} {...reste} />;
});

export default Link;
